export const getFormDataFromAudio = (blob: Blob) => {
  const formData = new FormData();
  formData.append("record", blob);
  formData.append("type", "binary");

  return formData;
};
